import * as React from "react";
import "./tab.component.css";
import { useEffect, useState } from "react";
import { MessageResponse } from "../../model/MessageResponse";
import {
    IconEdit,
  IconHistory,
  IconSearch,
} from "@tabler/icons-react";
import {
  MRT_ColumnFiltersState,
  MRT_SortingState,
  MRT_PaginationState,
  MRT_RowSelectionState,
  MRT_ColumnDef,
  useMantineReactTable,
  MantineReactTable,
} from "mantine-react-table";
import {
  ActionIcon,
  Box,
  Button,
  Flex,
  Input,
  Tooltip,
} from "@mantine/core";
import ProcessInstancesModel from "../../model/ProcessInstancesModel";
import { _localization } from "../../config/location";
import { pageTable } from "../../_base/_const/_constVar";
const EmailTemplate = () => {
  //#region  table

  //data and fetching state
  const [data, setData] = useState<ProcessInstancesModel[]>([]);
  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isRefetching, setIsRefetching] = useState(false);
  const [rowCount, setRowCount] = useState(0);

  //table state
  const [columnFilters, setColumnFilters] = useState<MRT_ColumnFiltersState>(
    []
  );
  const [globalFilter, setGlobalFilter] = useState("");
  const [sorting, setSorting] = useState<MRT_SortingState>([]);
  const [pagination, setPagination] = useState<MRT_PaginationState>({
    pageIndex: 0,
    pageSize: 20,
  });
  const [rowSelection, setRowSelection] = useState<MRT_RowSelectionState>({});


  useEffect(() => {
    fetchData();
  }, [pagination.pageIndex, pagination.pageSize]);

  const [keySearch, setKeySearch] = useState<string>("");

  const fetchData = async () => {
    setIsLoading(true);
    setIsRefetching(true);
    setOpenedMenu(false);
    const url = new URL("/api/v1/admin/email", "https://localhost:7118");
    url.searchParams.set("page", `${pagination.pageIndex}`);
    url.searchParams.set("pageSize", `${pagination.pageSize}`);
    if (keySearch && keySearch.length > 0)
      url.searchParams.set("key", `${keySearch}`);
    try {
      const response = await fetch(url.href);
      const json = (await response.json()) as MessageResponse<any>;
      setData(json.data.data);
      setRowCount(json.data.count);
    } catch (error) {
      setIsError(true);
      console.error(error);
      return;
    }
    setIsError(false);
    setIsLoading(false);
    setIsRefetching(false);
  };

  function progessTemplate(props: any): any {
    return (
      <>
        <Tooltip label="Chỉnh sửa">
          <ActionIcon variant="light" aria-label="Settings" color="blue">
            <IconEdit size={14} stroke={1.5} />
          </ActionIcon>
        </Tooltip>
      </>
    );
  }

  const columns = React.useMemo<MRT_ColumnDef<any>[]>(
    () => [
      {
        accessorKey: "id",
        header: "Id",
        size: 30,
      },
      {
        accessorKey: "code",
        header: "Mã Email",
        size: 30,
      },
      {
        accessorKey: "type",
        header: "Loại email",
        size: 50,
      },
      {
        accessorKey: "content",
        header: "Nội dung",
        size: 50,
      },
      {
        accessorKey: "date",
        header: "Ngày cập nhật",
      },
      {
        accessorKey: "action",
        header: "Thao tác",
        size: 50,
        Cell: ({ renderedCellValue, row }) => (
          <Box
            style={{
              display: "flex",
              alignItems: "center",
              gap: "16px",
            }}
          >
            {progessTemplate(renderedCellValue)}
          </Box>
        ),
      },
    ],
    []
  );
  const [openedMenu, setOpenedMenu] = useState(true);
  React.useEffect(() => {
    //do something when the row selection changes...
    console.info({ rowSelection });
  }, [rowSelection]);

  const table = useMantineReactTable({
    columns,
    data,
    positionToolbarAlertBanner: "bottom",
    //add custom action buttons to top-left of top toolbar
    renderTopToolbarCustomActions: ({ table }) => (
      <>
        <Flex
          gap="md"
          justify="flex-start"
          align="center"
          direction="row"
          wrap="wrap"
        >
          <Input
            placeholder="Nhập từ khóa"
            onChange={(e) => {
              setKeySearch(e.target.value ?? "");
            }}
          />
          <Button
            leftSection={<IconSearch size={14} />}
            color="blue"
            variant="outline"
            onClick={async () => {
              await fetchData();
            }}
          >
            Tìm kiếm
          </Button>
        </Flex>
      </>
    ),
    renderToolbarInternalActions: ({ table }) => <></>,

    localization: _localization,
    enableRowSelection: true,
    getRowId: (row) => row.id,
    initialState: {
      showColumnFilters: false,
      columnPinning: {
        //   left: ["mrt-row-select", "code"],
        right: ["action"],
      },
      columnVisibility: { id: false },
      density: "xs",
    },
    mantineTableContainerProps: { style: { maxHeight: "60vh" } },
    enableStickyHeader: true,
    onRowSelectionChange: setRowSelection,
    manualFiltering: true,
    manualPagination: true,
    manualSorting: true,
    rowCount,
    onColumnFiltersChange: setColumnFilters,
    onGlobalFilterChange: setGlobalFilter,
    onPaginationChange: setPagination,
    onSortingChange: setSorting,
    mantineTableBodyCellProps: ({ row }) => ({
      style: {
        //  fontWeight: row.getIsSelected() ? "bold" : "normal", //conditional styling
        fontWeight: "bold", //conditional styling
        fontSize: "12.5px",
        padding: "5px 15px",
      },
    }),
    state: {
      columnFilters,
      globalFilter,
      isLoading,
      pagination,
      showAlertBanner: isError,
      showProgressBars: isRefetching,
      showSkeletons: isLoading, //loading for the first time with no data
      sorting,
      rowSelection,
    },
    mantineToolbarAlertBannerProps: isError
      ? { color: "red", children: "Lỗi tải dữ liệu !" }
      : undefined,
    mantinePaginationProps: {
      showRowsPerPage: true,
      withEdges: true,
      rowsPerPageOptions: pageTable,
    },
    paginationDisplayMode: "pages",
    enableColumnPinning: true,
    mantineTableProps: {
      striped: true,
    },
  });

  //#endregion
  return (
    <>
      <div className="mt-5">
        <MantineReactTable table={table} />
      </div>
    </>
  );
};
export default EmailTemplate;
